import React, { useLayoutEffect, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import { fetchWorks } from '../utils/apiService';

// Fallback Image
import imgDelivery from '../assets/image/delivery_web_app.jpg';

const Portfolio = () => {
    const [works, setWorks] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useLayoutEffect(() => {
        // Trigger animations for this section
        const timer = setTimeout(() => {
            if (window.animationText) window.animationText();
            if (window.scrollingEffect) window.scrollingEffect();
            if (window.animateImgItem) window.animateImgItem();

            // Refresh ScrollTrigger as content might have changed
            if (window.ScrollTrigger) {
                window.ScrollTrigger.refresh();
            }
        }, 800);

        return () => {
            clearTimeout(timer);
            if (window.revertAnimations) window.revertAnimations();
            if (window.revertHeadline) window.revertHeadline();
        };
    }, [works]);

    useEffect(() => {
        const getWorks = async () => {
            setIsLoading(true);
            const result = await fetchWorks();
            if (result && result.status && result.data) {
                // Sort works by sort_order
                const sortedWorks = [...result.data].sort((a, b) => {
                    const orderA = a.sort_order || 0;
                    const orderB = b.sort_order || 0;
                    return orderA - orderB;
                });
                setWorks(sortedWorks);
            }
            setIsLoading(false);
        };
        getWorks();
    }, []);

    const getImageUrl = (imgVal) => {
        if (!imgVal) return imgDelivery; // Fallback
        const imgStr = imgVal.toString().trim();
        return imgStr.startsWith('http')
            ? imgStr
            : `${process.env.REACT_APP_STORAGE_BASE_URL || 'http://localhost:8000/storage'}/${imgStr}`;
    };

    return (
        <div className="wrapper position-relative">
            <Header />

            <div className="page-title">
                <div className="tf-container">
                    <div className="page-title-content text-center">
                        <h1 className="title" dangerouslySetInnerHTML={{ __html: '<span class="split-text effect-right">Our Works</span>' }} />
                        <div className="breadkcum">
                            <Link to="/" className="link-breadkcum body-2 fw-7">
                                <span className="split-text effect-right" dangerouslySetInnerHTML={{ __html: 'Home' }} />
                            </Link>
                            <span className="dot"></span>
                            <span className="page-breadkcum body-2 fw-7">
                                <span className="split-text effect-right" dangerouslySetInnerHTML={{ __html: 'Portfolio' }} />
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-content">
                <div className="tf-container tf-spacing-2">
                    {isLoading ? (
                        <div className="text-center py-5">
                            <p>Loading works...</p>
                        </div>
                    ) : works.length === 0 ? (
                        <div className="text-center py-5">
                            <p>No works available.</p>
                        </div>
                    ) : (
                        works.map((work, index) => (
                            <div
                                key={work.id}
                                className={`project-item ${index % 2 === 0 ? 'style-reverse' : ''} style-2 mb-70`}
                            >
                                <div className="item-content">
                                    <div className="top-content">
                                        <div className="sub-title body-2 fw-7">
                                            {work.subtitle}
                                        </div>
                                        <h3
                                            className="title-project"
                                            dangerouslySetInnerHTML={{
                                                __html: `<a href="${work.links || '#'}" target="_blank" rel="noopener noreferrer">${work.title}</a>`
                                            }}
                                        />
                                        <div
                                            className="desc lh-30"
                                            dangerouslySetInnerHTML={{ __html: work.description }}
                                        />
                                    </div>
                                </div>
                                {/* <Link to={work.links || '#'} className="image">
                                    <img
                                        src={getImageUrl(work.image)}
                                        alt={work.title}
                                        className="ls-is-cached lazyloaded"
                                    />
                                </Link> */}
                                <a href={work.links || '#'} target="_blank" rel="noopener noreferrer" className="image">
                                    <img
                                        src={getImageUrl(work.image)}
                                        alt={work.title}
                                        className="ls-is-cached lazyloaded"
                                    />
                                </a>
                            </div>
                        ))
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Portfolio;
